module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_1-bd8c36f67819e84aa98282d717e23c82.webp";